import { z } from 'zod';

export const MapMemberDTO = z.object({
  id: z.string(),
  name: z.string(),
  company: z.string().nullable().optional(),
  industry: z.string().nullable().optional(),
  city: z.string().nullable().optional(),
  country: z.string().nullable().optional(),
  lat: z.number(),
  lng: z.number(),
  tags: z.array(z.string()),
  /** Für die Avatar-Marker; Fotos sind clientseitig auf ~512px komprimiert. */
  photoUrl: z.string().nullable().optional(),
});
export type MapMemberDTO = z.infer<typeof MapMemberDTO>;

export const MapWithoutLocationDTO = z.object({
  id: z.string(),
  name: z.string(),
  company: z.string().nullable().optional(),
});
export type MapWithoutLocationDTO = z.infer<typeof MapWithoutLocationDTO>;

export const MapResponse = z.object({
  members: z.array(MapMemberDTO),
  withoutLocation: z.array(MapWithoutLocationDTO),
});
export type MapResponse = z.infer<typeof MapResponse>;

// Treffer der Ortssuche ("Standort setzen" in der Karten-Seitenleiste).
export const GeoPlaceDTO = z.object({
  label: z.string(),
  city: z.string().nullable(),
  country: z.string().nullable(),
  lat: z.number(),
  lng: z.number(),
});
export type GeoPlaceDTO = z.infer<typeof GeoPlaceDTO>;

export const GeoSearchResponse = z.object({
  results: z.array(GeoPlaceDTO),
});
export type GeoSearchResponse = z.infer<typeof GeoSearchResponse>;
